export default "__VITE_ASSET__CeC8q5kT__"